//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'BaseIcon',
  props: {
    icon: {
      type: String,
      default: 'uil:check'
    },
    size: {
      type: String,
      default: 'base'
    },
    customSize: {
      type: String,
      default: ''
    }
  }
};